import { initOptions } from './options';
import { DEFAULT_OPTIONS } from '../constants';

export const contextKey = 'timeout';

const defaultOptions = DEFAULT_OPTIONS.TIMEOUT;

let pTimeoutModule;

export const getWrapper = (nextAction, context) => {
	initOptions(context, contextKey, defaultOptions);
	return async (fnArgs, executionContext) => {
		if (!pTimeoutModule) {
			pTimeoutModule = await import('p-timeout');
		}
		const { timeout } = executionContext[contextKey].options;
		return pTimeoutModule.default(nextAction(fnArgs, executionContext), {
			milliseconds: timeout,
			message: `${executionContext.name} promise timed out after ${timeout} milliseconds`,
		});
	};
};

getWrapper.contextKey = contextKey;
